import { useMutation } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

const patchObservationQuestion = async ({
	id,
	...payload
}: Partial<IAdminQuestion>) => {
	const url = `/observations/admin/questions/${id}/`;

	const response = await cmsClient.patch<IAdminQuestion>(url, payload);

	return response.data;
};

const usePatchObservationQuestion = () => {
	const mutation = useMutation(patchObservationQuestion);
	return mutation;
};

export default usePatchObservationQuestion;
